import { Divider, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Content, PendingSpinner } from '@/core/components';

import { MAX_UPLOAD_SIZE_MB } from '@feature/utils/upload/fileUpload';

import { getTravelReferenceDocumentSlotsOptions } from '../model/TravelReferenceDocumentQuery';
import { TravelReferenceDocumentSlotRow } from './TravelReferenceDocumentSlotRow';

export function TravelReferenceDocumentsCard() {
  const { t } = useTranslation();
  const { data, isPending, isError } = useQuery(getTravelReferenceDocumentSlotsOptions());

  return (
    <Content
      type="full"
      title={t('travel.referenceDocuments.title')}
    >
      <Text
        c="dimmed"
        size="sm"
        fs="italic"
      >
        {t('travel.referenceDocuments.hint', { maxSize: MAX_UPLOAD_SIZE_MB })}
      </Text>
      {isPending && <PendingSpinner h="120px" />}
      {isError && (
        <Text
          role="alert"
          c="red"
          size="sm"
        >
          {t('travel.referenceDocuments.listFailed')}
        </Text>
      )}
      {data != null && (
        <Stack gap="sm">
          {data.map((slot, index) => (
            <Fragment key={`${slot.kind}:${slot.role ?? ''}`}>
              {index > 0 && <Divider />}
              <TravelReferenceDocumentSlotRow slot={slot} />
            </Fragment>
          ))}
        </Stack>
      )}
    </Content>
  );
}
